import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Button, Spin, Tooltip } from 'antd';
import Wrapper from '../Wrapper/Wrapper';
import { roundIconBgTypes } from '../../constants/common';
import styles from './RoundIconBackground.module.scss';

const RoundIconBackground = forwardRef(
  (
    {
      size = 'large',
      containerType = roundIconBgTypes.transparent,
      onClick,
      renderIcon,
      className,
      tooltipTitle = '',
      getTooltipContainer = () => document.body,
      loading = false,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <Tooltip title={tooltipTitle} getPopupContainer={getTooltipContainer}>
        <Wrapper
          {...props}
          ref={ref}
          el={typeof onClick === 'function' ? Button : 'div'}
          onClick={onClick}
          className={cn(
            styles.root,
            styles[size],
            styles[containerType],
            className,
            {
              [styles.hovered]: typeof onClick === 'function',
            }
          )}
        >
          <Spin spinning={loading} className={styles.spin} />
          {typeof renderIcon === 'function' &&
            renderIcon({ className: cn(styles.icon) })}
          {children}
        </Wrapper>
      </Tooltip>
    );
  }
);

export default RoundIconBackground;
